import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AdminAuthContext = createContext();

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('adminToken'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      fetchCurrentAdmin();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchCurrentAdmin = async () => {
    try {
      // Check if user data is stored in localStorage
      const storedUser = localStorage.getItem('adminUser');
      if (storedUser) {
        const userData = JSON.parse(storedUser);
        setAdmin(userData);
        setLoading(false);
        return;
      }

      // If no stored data, try to fetch from API (for admin only)
      const response = await axios.get(`${API}/admin/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAdmin(response.data);
      localStorage.setItem('adminUser', JSON.stringify(response.data));
    } catch (error) {
      console.error('Failed to fetch admin:', error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (mobile, password) => {
    try {
      // All logins now use mobile number
      const response = await axios.post(`${API}/admin/auth/login`, { 
        mobile, 
        password 
      });
      
      const { token: newToken, admin: adminData } = response.data;
      
      localStorage.setItem('adminToken', newToken);
      localStorage.setItem('adminUser', JSON.stringify(adminData));
      setToken(newToken);
      setAdmin(adminData);
      
      return { success: true };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.error || 'Login failed' 
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    setToken(null);
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, token, login, logout, loading }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => {
  const context = useContext(AdminAuthContext);
  if (!context) {
    throw new Error('useAdminAuth must be used within AdminAuthProvider');
  }
  return context;
};